import PortalAppService from "../../../application/platform/portal-app-service";
import BaseAppService from "../../../application/platform/base-app-service";
import { ACTION_TYPES, usePublicationsDispatch } from "./publications-context";
import { IListPublicationsRequest } from "../../../model/base/request/list-publications-request";
import { IGetListSubcategoryPublicationRequest } from "../../../model/base/request/get-list-subcategory-publication-request";

export const usePublicationsController = () => {
    const PublicationsDispatch = usePublicationsDispatch();

    async function loadData(request: IListPublicationsRequest) {
        try {
            PublicationsDispatch({
                type: ACTION_TYPES.setLoading,
                payload: true,
            });

            const result = await PortalAppService.requestPublications(request);

            PublicationsDispatch({
                type: ACTION_TYPES.setPublications,
                payload: result,
            });
        } catch (error) {
            console.error('Erro ao carregar publicações:', error);
            PublicationsDispatch({
                type: ACTION_TYPES.setLoading,
                payload: false,
            });
        }
    }

    async function loadCategories() {
        try {
            PublicationsDispatch({
                type: ACTION_TYPES.setLoadingFilters,
                payload: true,
            });

            const categories = await BaseAppService.getListCategoryPublication();

            PublicationsDispatch({
                type: ACTION_TYPES.setCategories,
                payload: categories,
            });
        } catch (error) {
            console.error('Erro ao carregar categorias:', error);
            PublicationsDispatch({
                type: ACTION_TYPES.setLoadingFilters,
                payload: false,
            });
        }
    }

    async function loadSubcategories(categoryId: number) {
        try {
            const request: IGetListSubcategoryPublicationRequest = {
                categoryId: categoryId
            };

            const subcategories = await BaseAppService.getListSubCategoryPublication(request);

            PublicationsDispatch({
                type: ACTION_TYPES.setSubcategories,
                payload: subcategories,
            });
        } catch (error) {
            console.error('Erro ao carregar subcategorias:', error);
            PublicationsDispatch({
                type: ACTION_TYPES.setSubcategories,
                payload: [],
            });
        }
    }

    function clearSubcategories() {
        PublicationsDispatch({
            type: ACTION_TYPES.setSubcategories,
            payload: [],
        });
    }

    return {
        loadData,
        loadCategories,
        loadSubcategories,
        clearSubcategories
    };
}
